import { Component, Injector, Optional, Input } from '@angular/core';
import { throwToolbarMixedModesError } from '@angular/material/toolbar';

import { Filter, FilterBuilder, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType } from '@mango/core';
import { Factuur } from 'src/app/core/dto/factuur';
import { FactuurStatusHistorie } from 'src/app/core/dto/factuurStatusHistorie';
import { FactuurStatusHistorieService } from 'src/app/core/service/factuurStatusHistorie.service';

@Component({
    selector: 'c-i-j-borculo-factuurStatusHistorie-collection',
    templateUrl: './factuurStatusHistorie-collection.component.html'/*,
    styleUrls: ['./factuurregel-collection.component.css'] */
})
export class FactuurStatusHistorieCollectionComponent extends PagedCollectionComponent<FactuurStatusHistorie> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<FactuurStatusHistorie>([
    { colDef: 'status', prop: x => x.status },
    { colDef: 'op', prop: x => x.op},
    { colDef: 'door', prop: x => x.door},
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: FactuurStatusHistorieService, @Optional() protected filter: Filter<FactuurStatusHistorie>, injector: Injector) {
        super('/factuurStatusHistorie/factuurStatusHistorie', injector, FactuurStatusHistorie);

      this.initInput('factuur', this.filterBuilder.equal(x => x.factuur.id));

      this.filter.onGetChipLabel(x => x.status, () => 'Status');
      this.filter.onGetChipLabel(x => x.op, () => 'Op');
      this.filter.onGetChipLabel(x => x.door, () => 'Door');

      this.orderBy=[-2];
    }

	displayColumn(colDef: ColumnDefinition, ix: number) {
			return super.displayColumn(colDef, ix);
	}
  
  isSelectableItem: (item: FactuurStatusHistorie) => boolean = item => { return false }

  private _factuur: Factuur;

	@Input() set factuur(val: Factuur) {
     this.handleInput('factuur', val.id);
     this._factuur = val;
  }

  canDelete() {
      return false;
  }

}